/** @jsxImportSource @emotion/react */
import React from 'react'
import {PostForm, PostPreview} from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/PostContext'
import { breadcrumbItems } from '../../utils'
import { Breadcrumb } from '../../../components/atoms'

const { index, contentManagement, managePost } = breadcrumbItems

const ManageNews: React.FC = () => {
  return (
    <Provider>
      <Breadcrumb items={[index, contentManagement, managePost]} />
      <div css={styles.root}>
        <div css={styles.main}>
          <PostForm />
        </div>
        <div css={styles.right}>
          <PostPreview />
        </div>
      </div>
    </Provider>
  )
}

export default ManageNews
